import { ProductBaseController } from '../../../src/internal/controllers/ProductBaseController';
import { action, computed, observable } from 'mobx';
import { IItem } from '../../api/ProdcatApiSdk';
import {
    IProductComparisonItem,
    IProductComparisonModule
} from '../../exported/product-comparison-module/ProductComparisonModule';
import { ProductRepository } from '../repositories/ProductRepository';
import { Product } from '../domain/entities/Product';

export class ProductComparisonModuleViewController extends ProductBaseController {
    @observable public productRepository: ProductRepository;
    @observable public isLoaded: boolean = false;
    @observable public products: Product[] = [];

    constructor(productRepository: ProductRepository) {
        super();
        this.productRepository = productRepository;
    }

    @action
    public initialize = async (props: IProductComparisonModule) => {
        const { items, collectionItems } = props.config;
        let itemParams: IItem[] = [];
        const productIds: string[] = [];
        const skuIds: string[] = [];

        if (items && items.length) {
            itemParams = items;
        } else if (collectionItems && collectionItems.length > 0) {
            collectionItems.forEach((collectionItem) => {
                if (collectionItem.productId) {
                    productIds.push(collectionItem.productId);
                } else if (collectionItem.skuId) {
                    skuIds.push(collectionItem.skuId);
                }
            });
        }

        if (itemParams.length) {
            this.products = await this.productRepository.getProductsByItems(itemParams);
        } else if (productIds.length || skuIds.length) {
            this.products = await this.productRepository.getProductsByIds({ productIds, skuIds });
        }

        this.isLoaded = true;
    };

    @computed
    public get data() {
        return {
            products: this.products
        };
    }

    public getProductById(param: IProductComparisonItem) {
        if (param.productId) {
            return this.productRepository.getProductById(param.productId);
        } else if (param.skuId) {
            return this.productRepository.getProductBySkuId(param.skuId);
        }
    }
}
